import axios from 'helpers/axios';
import { useToasts } from 'hooks';
import React, { useEffect } from 'react';
import { CodeEditor } from 'ui/components/shared/CodeEditor';
import { Button, Container, Select, Title } from 'ui/components/styled';

export default function EmailTemplates() {
  const [templates, setTemplates] = React.useState([]);
  const [selectedTemplate, setSelectedTemplate] = React.useState(null);
  const [content, setContent] = React.useState('');

  const [mode, setMode] = React.useState('code');
  const [preview, setPreview] = React.useState('');
  const { errorToast, successToast } = useToasts();

  const saveTemplate = async () => {
    try {
      const response = await axios.post(`/branding/email-templates/save-template`, {
        path: selectedTemplate.value,
        content: content,
      });
      setPreview(() => response.data);
      successToast('Template has been saved successfully');
    } catch (e) {
      errorToast('Error while saving the template');
    }
  };

  const handleChange = (newValue) => {
    setContent(newValue);
  };

  const toggleMode = () => {
    if (mode === 'code') saveTemplate();
    setMode((mode) => (mode === 'code' ? 'preview' : 'code'));
  };
  const fetchTemplatesList = async () => {
    try {
      const response = await axios.get('/branding/email-templates');
      setTemplates(
        response.data.map((template) => ({
          label: template.name,
          value: template.path,
        }))
      );
    } catch (e) {
      errorToast('Error while fetching templates list');
    }
  };

  const fetchTemplateContent = async (path) => {
    try {
      const response = await axios.post(`/branding/email-templates/get-template`, { path });
      setContent(response.data);
    } catch (e) {
      errorToast('Error while fetching template content');
    }
  };

  const handleSelectChange = (option) => {
    if (!option) return;
    setSelectedTemplate(option);
    fetchTemplateContent(option.value);
    setMode('code');
  };

  useEffect(() => {
    fetchTemplatesList();
  }, []);

  return (
    <Container>
      <Title>Email Settings</Title>
      <Container flexDirection="row" mb="l" height="max-content" justifyContent="center" gap="m">
        <Container maxWidth="300px">
          <Select
            value={selectedTemplate}
            options={templates}
            onChange={handleSelectChange}
            placeholder="Select a template"
          />
        </Container>

        <Container maxWidth="300px">
          <Button onClick={toggleMode}>{mode === 'code' ? 'Save & Preview' : 'Edit'}</Button>
        </Container>
      </Container>
      <CodeEditor handleChange={handleChange} template={content} mode={mode} preview={preview} />
    </Container>
  );
}
